import React from 'react';
import { Doughnut } from 'react-chartjs-2';

/**
 *
 */
export function DoughnutChart(props) {
  const chartOptions = {
    elements: {
      arc: {
        borderColor: 'rgb(24,18,30)',
        borderWidth: 0
      }
    },
    legend: {
      display: false
    },
    tooltips: {
      callbacks: {
        title: (tooltipItem, data) => data.labels[tooltipItem[0].index],
        label: (tooltipItem, data) => `${data.datasets[0].data[tooltipItem.index]}%`
      }
    }
  };

  return (
    <div className="doughnut-chart">
      <Doughnut data={props.data} options={chartOptions} redraw={false} />
    </div>
  );
}
